class SportModal {
    constructor(){
        this.closeModal = document.querySelector("#close-modal")
        this.modalBox = document.querySelector("#modal-box")
        this.overlay = document.querySelector("#overlay")
        
        this.modalTitle = document.querySelector("#title")
        this.modalTerm = document.querySelector("#term")
        this.modalDescription = document.querySelector("#description")
        this.modalSport = document.querySelector("#sport-name span")
        this.modalAddress = document.querySelector("#sport-address span")
        this.modalNumber = document.querySelector("#sport-number a")
        this.modalImage = document.querySelector("#modal-box img")


        this.filterpanel = document.querySelectorAll(".filterpanel")

        this.addEvents()
    }

    addEvents(){
        // Close button
        this.closeModal.addEventListener("click", () => {
            this.closePopup()
        })

        // Click outside modal (overlay)
        this.overlay.addEventListener("click", () => {
            this.closePopup()
        })

       this.filterpanel.forEach(card => {

            card.addEventListener("click", (e) => {

                const title = card.dataset.title
                const description = card.dataset.description
                const term = card.dataset.popup
                const address = card.dataset.address
                const number = card.dataset.number
                const image = card.dataset.image
                const name = card.dataset.name

                this.modalTitle.textContent = title
                this.modalDescription.textContent = description
                if(term == "Indoor"){
                    this.modalTerm.classList.remove("bg-accent/10","text-accent")
                    this.modalTerm.classList.add("bg-primary/10","text-primary")
                }else{
                    this.modalTerm.classList.remove("bg-primary/10","text-primary")
                    this.modalTerm.classList.add("bg-accent/10","text-accent")
                }
                this.modalTerm.textContent = term
                this.modalAddress.textContent = address
                this.modalNumber.textContent = number
                this.modalNumber.href = `tel:${number}`
                this.modalImage.src = image
                this.modalSport.textContent = name

                this.modalBox.classList.remove("hidden")
                this.overlay.classList.remove("hidden")

                // disable page scroll
                document.body.classList.add("overflow-hidden")
                document.documentElement.classList.add("overflow-hidden")

            })

        })

    }

    closePopup(){
        this.modalBox.classList.add("hidden")
        this.overlay.classList.add("hidden")

        // enable page scroll
        document.body.classList.remove("overflow-hidden")
        document.documentElement.classList.remove("overflow-hidden")
    }

}

export default SportModal